import {
  Box,
  Flex,
  Text,
  HStack,
  Icon,
  useBreakpointValue,
  IconButton,
} from '@chakra-ui/react';
import { NavigationTabs } from './conversation-navigation-tabs';
import { FiInbox, FiMenu } from 'react-icons/fi';

interface ConversationHeaderProps {
  isMobile: boolean;
  onSidebarToggle?: () => void;
  activeTab: string;
  onTabChange: (tab: string) => void;
  isEmployee?: boolean;
  isAdmin?: boolean;
  isManager?: boolean;
  roleName?: string;
}

function ConversationHeader({
  isMobile,
  onSidebarToggle,
  activeTab,
  onTabChange,
  isEmployee = false,
  isAdmin = false,
  isManager = false,
  roleName,
}: ConversationHeaderProps) {
  const padding = useBreakpointValue({ base: 3, md: 4 });
  const displayRole = roleName
    ? roleName.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())
    : undefined;

  return (
    <Box
      as="header"
      height="72px"
      minHeight="72px"
      maxHeight="72px"
      py={padding}
      px={padding}
      borderBottomWidth="1px"
      borderBottomStyle="solid"
      borderBottomColor="gray.200"
      bg="white"
      width="100%"
      position="relative"
      isolation="isolate"
      zIndex={10}
      flexShrink={0}
    >
      <Flex
        align="center"
        justify="space-between"
        position="relative"
        height="100%"
        wrap={{ base: 'wrap', md: 'nowrap' }}
        gap={4}
        width="100%"
        overflow="visible"
      >
        {/* Left side - Title with icon and mobile menu */}
        <Flex align="center" flex="0 0 auto" zIndex={2} flexShrink={0}>
          {isMobile && (
            <IconButton
              variant="ghost"
              aria-label="Open menu"
              mr={2}
              onClick={onSidebarToggle}
              size="md"
              colorPalette="gray"
            >
              <Icon as={FiMenu} boxSize={5} />
            </IconButton>
          )}
          <HStack gap={2}>
            <Icon as={FiInbox} boxSize={5} color="gray.700" display="block" />
            <Text
              fontWeight="medium"
              fontSize="lg"
              color="gray.900"
              lineHeight="1.2"
              letterSpacing="tight"
            >
            </Text>
            {displayRole && (
              <Text
                fontSize="xs"
                color="gray.600"
                px={2}
                py={0.5}
                bg="gray.100"
                borderRadius="full"
                textTransform="capitalize"
              >
                {displayRole}
              </Text>
            )}
          </HStack>
        </Flex>

        <Box flex="1" minWidth="0" display="flex" justifyContent="flex-end" overflow="visible">
          <NavigationTabs
            activeTab={activeTab}
            onTabChange={onTabChange}
            isEmployee={isEmployee}
            isAdmin={isAdmin}
            isManager={isManager}
          />
        </Box>
      </Flex>
    </Box>
  );
}

export default ConversationHeader;
